import {
  Avatar as ChakraAvatar,
  AvatarProps as ChakraAvatarProps,
} from '@chakra-ui/react'
import { Icon } from '../Icon/Icon'
import { SwashbuckleComponentProps, SemanticColorSchemes } from '../../types'

export type AvatarProps = {
  colorScheme?: SemanticColorSchemes
  variant?: 'noBorder'
} & Omit<
  SwashbuckleComponentProps<ChakraAvatarProps>,
  | 'colorScheme'
  | 'getInitials'
  | 'icon'
  | 'ignoreFallback'
  | 'loading'
  | 'onError'
  | 'referrerPolicy'
  | 'showBorder'
>

export const Avatar = ({
  'data-qa': dataQa,
  name,
  className,
  ...chakraProps
}: AvatarProps) => {
  return (
    <ChakraAvatar
      data-qa={dataQa}
      className={className}
      icon={
        <Icon
          name='default-avatar'
          title={name}
          color='var(--hb-colors-brand-500)'
          width='100%'
          height='100%'
        />
      }
      {...chakraProps}
    />
  )
}

Avatar.displayName = 'Avatar'
